import "./index.css";
import classes from "../../../../utils/HTML/classes";
import { LanguageType } from "../../../../models/IInteractiveAudio";
import { ReactComponent as AddIcon } from "assets/icons/Common/add-icon.svg";
import { ReactNode } from "react";

export interface SecondaryLanguageSwitchProps {
  onSelectPrimary: () => void;
  onSelectSecondary: () => void;
  onCreateSecondary: () => void;
  activeLanguage: LanguageType;
  hasSecondary: boolean;
  addButtonWrapper?: (button: ReactNode) => ReactNode;
}

export const SecondaryLanguageSwitch = ({
  onSelectSecondary,
  onSelectPrimary,
  onCreateSecondary,
  hasSecondary,
  activeLanguage,
  addButtonWrapper,
}: SecondaryLanguageSwitchProps) => {
  const showSecondary = hasSecondary || activeLanguage === LanguageType.SECONDARY;

  const addButton = (
    <button
      className="add-button cpat-button cpat-button--icon"
      title="Add Audio"
      onClick={onCreateSecondary}
      type="button"
    >
      <AddIcon />
    </button>
  );

  return (
    <div className="language-switch__wrapper">
      <button
        className={classes("language-switch__button", { "button--active": activeLanguage === LanguageType.PRIMARY })}
        onClick={onSelectPrimary}
        type="button"
        aria-label="Select Primary Audio"
      >
        1
      </button>
      {showSecondary && (
        <button
          aria-label="Select Secondary Audio"
          className={classes("language-switch__button", {
            "button--active": activeLanguage === LanguageType.SECONDARY,
          })}
          onClick={onSelectSecondary}
        >
          2
        </button>
      )}

      {!showSecondary && (
        <div className="add-button-container">{addButtonWrapper ? addButtonWrapper(addButton) : addButton}</div>
      )}
    </div>
  );
};
